import React from 'react';

import { FREQUENCY_EXPENSE_OPTIONS, FREQUENCY } from '@funnels/constants';

import { DropdownField } from '../../../Fields';
import { FunnelViewProps } from '../../types';

import { NeedsAndAnalysisCommon } from '../NeedsAndAnalysisCheckboxVariationCustomerView';

interface EstimatedImpactFrequencyProps extends FunnelViewProps, Omit<NeedsAndAnalysisCommon, 'label'> {
  defaultValue?: FREQUENCY;
}

export const EstimatedImpactFrequency: React.FC<EstimatedImpactFrequencyProps> = (props) => {
  const { name, defaultValue, ...rest } = props;

  return (
    <DropdownField {...rest} name={name} options={FREQUENCY_EXPENSE_OPTIONS} defaultValue={defaultValue} isFullWidth />
  );
};
